import React from "react";
import "./ChatLoader.css";

const ChatLoader = () => {
  return (
    <div className="loader">
      <span className="dot"></span>
      <span className="dot"></span>
      <span className="dot"></span>
    </div>
  );
};

export default ChatLoader;
